import { SeatInterface, Stretches, Vis, AddCallBackType, RemoveCallBackType, OperationLine, BusinessUnit, Extras } from '../@types/Data';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import FullCalendar from '@fullcalendar/react'
import interactionPlugin from "@fullcalendar/interaction";
import { getTrayectoByID, addToCart, getOperationLine} from '../utils/RequestMaker';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import dayGridPlugin from '@fullcalendar/daygrid'
import SeatPicker from "react-seat-picker";
import Moment from 'moment';
import '../styles/style.css';
import { useHistory } from 'react-router';
import { RouteComponentProps } from 'react-router';
import { generateTokenticket, mountPayload, primeraLetraMayuscula } from '../utils/Utils';

interface TrayectoParams {
    id: string;
    id_operationLine: string;
}

type TrayectoProps = RouteComponentProps<TrayectoParams>;

export const Trayecto: React.FC<TrayectoProps> = (props: TrayectoProps) => {
    const stretchID = props.match.params.id;
    const operationLineID = +props.match.params.id_operationLine;
    const history = useHistory();
    const TICKET_LENGTH = 16;
    const imagen = 'https://res.cloudinary.com/marketingpyme/image/upload/w_512,h_384,c_fill/servicios/' + operationLineID + "-" + stretchID + ".jpg";
    const init: Vis = {names: [], vis: [], price: [], base: 0.00, total: 0.00, extras: []};
    // const COLLABORATOR_LENGTH = 20;
    
    const [trayecto, setTrayecto] = useState<Stretches>();
    const [operationLine, setOperationLine] = useState<OperationLine>();
    const [bu, setBU] = useState<BusinessUnit>();

    const [openDatePopup, setOpenDatePopup] = useState<boolean>(false);
    const [openReservarPopup, setOpenReservarPopup] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [visitas, setVisitas] = useState<Vis>(init);
    const [dd, setDD] = useState<Object[]>([]);
    const [dateClicked, setDateClicked] = useState<string>("");
    const [selectedHour, setSelectedHour] = useState<string>("");
    const [totalSeats, setTotalSeats] = useState<number>(0);
    const [disabled, setDisabled] = useState<boolean>(false);

    let description = useRef('');
    let additional_info = "";
    let amount = 0;

    useEffect(() => {

        if(!bu && !operationLine) {
            getOperationLine(operationLineID).then((res) => {
                setOperationLine(res);
                setBU(res.businessUnit);
            });
        }

        if(!trayecto && operationLine) {
            getTrayectoByID(operationLine.id, +stretchID).then((res) => {
                setTrayecto(res);
            });
        } else if (trayecto) {
            description.current = trayecto.name;
            let auxDD: Object[] = [];
            if(trayecto.disabledDays) {
                trayecto.disabledDays.forEach((disabledDay) => {
                    let str='{ "title": "No Disponible", ';
                    const date = new Date(disabledDay.year, disabledDay.month, disabledDay.day);
                    str += '"date": "' + Moment(date).format("YYYY-MM-DD") + '", ';
                    str += '"constraint": "noDisponible", ';
                    str += '"backgroundColor": "#ff9f89", '
                    str += '"display": "background"';
                    str += '}';
                    let strjs = JSON.parse(str);
                    auxDD.push(strjs);
                });
    
                setDD(auxDD);
            }

            if(trayecto.prices) {
                setDisabled(trayecto.prices.length === 0);
                let auxVis: number[] = [];
                let auxPrice: number[] = [];
                let auxNames: string[] = [];
                trayecto.prices.forEach((precio) => {
                    auxVis.push(0);
                    auxPrice.push(0.00);
                    auxNames.push(precio.passengerCategory.name);
                });
                setVisitas({names: auxNames, vis: auxVis, price: auxPrice, base: 0.00, total: 0.00, extras: []});
                setTotalSeats(0);
            } else {
                setDisabled(true);
            }
            const horas = trayecto.horasIda;
            if(horas && horas.length !== 0 && selectedHour === "") {
                setSelectedHour(horas[0].hours + ":" + horas[0].minutes);
            }
        }
    }, [trayecto, stretchID, selectedHour, operationLine, bu, operationLineID]);

    const clickDateHandler = (arg: any) => {
        const date = arg.date;
        let pertenece:boolean = false;

        if(trayecto && trayecto.disabledDays) {
            trayecto.disabledDays.forEach((disabledDay) => {
                const dateDisabledDay = Moment(new Date(disabledDay.year, disabledDay.month, disabledDay.day)).format("YYYY-MM-DD");
                if(date === dateDisabledDay) pertenece = true;
            });
        }
        let todaysDate = new Date();
        todaysDate.setHours(0, 0, 0, 0);

        let dateParsed = new Date(date);
        const beforeToday = dateParsed < todaysDate;
        if(!pertenece && !beforeToday) {
            //"2020-08-04T14:58:01.415Z"
            setDateClicked(Moment(date).format());
        } else {
            setOpenDatePopup(true);
        }
    }

    const closeClickDateHandler = () => {
        setOpenDatePopup(false);
    };

    const closeClickReservarHandler = () => {
        setOpenReservarPopup(false);
    };

    const addVisitante =  (event: any) => {
        const index = event.currentTarget.value;
        if(trayecto && index) {
            const precioBase = trayecto.prices[index].price;
            const precio = precioBase + precioBase * trayecto.tax.value;
            const names = visitas.names.slice();
            const extras = visitas.extras.slice();
            let auxVis = visitas.vis.slice();
            let auxPrice = visitas.price.slice();
            let base = visitas.base;
            let tot = visitas.total;
            auxVis[index]++;
            auxPrice[index] += precio;
            base += precioBase;
            tot += precio;
            setVisitas({names: names, vis: auxVis, price: auxPrice, base: base, total: tot, extras: extras});
            let auxTot = totalSeats;
            auxTot++;
            setTotalSeats(auxTot);
        }
    };

    const extrasChangeHandler = useCallback((event) => {
        const index = event.currentTarget.value;
        if(trayecto && trayecto.extras) {
            const extra = trayecto.extras[index];
            const precioBaseExtra = extra.price;
            const precioTotalExtra = extra.price + extra.price * extra.tax.value;
            if(event.currentTarget.checked) {
                // Añadir el extra al presupuesto
                let auxExtras = visitas.extras.slice();
                auxExtras.push(extra);
                setVisitas({
                    names: visitas.names, vis: visitas.vis, price: visitas.price, base: visitas.base + precioBaseExtra, total: visitas.total + precioTotalExtra, extras: auxExtras
                });
            } else {
                // Eliminar el extra del presupuesto
                let auxExtras = visitas.extras.slice();
                let indexExtra = -1;
                auxExtras.forEach((res) => { if(res.id === extra.id) indexExtra = auxExtras.indexOf(res)});
                auxExtras.splice(indexExtra, 1);
                setVisitas({
                    names: visitas.names, vis: visitas.vis, price: visitas.price, base: visitas.base - precioBaseExtra, total: visitas.total - precioTotalExtra, extras: auxExtras
                });
            }
        }
    }, [trayecto, visitas]);
    
    const quitarVisitante = (event: any) => {
        const index = event.currentTarget.value;
        if(trayecto && index) {
            const precioBase = trayecto.prices[index].price;
            const precio = precioBase + precioBase * trayecto.tax.value;
            const names = visitas.names.slice()
            const extras = visitas.extras.slice();
            let auxVis = visitas.vis.slice();
            let auxPrice = visitas.price.slice();
            let tot = 0.00;
            let base = 0.00;
            if(auxVis[index] > 0) {
                auxVis[index]--;
            }
            auxPrice[index] = precio * auxVis[index];
            auxVis.forEach((a) => {
                const index = auxVis.indexOf(a);
                const pb = trayecto.prices[index].price;
                const p = pb + pb * trayecto.tax.value;
                base += auxVis[index] * pb;
                tot += auxVis[index] * p;
            });
            setVisitas({names: names, vis: auxVis, price: auxPrice, base: base, total: tot, extras: extras});
            let auxTot = totalSeats - 1;
            setTotalSeats(auxTot);
        }
    };

    const horaChangeHandler = (event: any) => {
        const index = event.currentTarget.value;
        if (index !== undefined && trayecto) {
            const hora = trayecto.horasIda[index]
            setSelectedHour(hora.hours + ":" + hora.minutes);
        }
    };

    const addSeatCallback = async ({row, number, id}: SeatInterface, addCb: AddCallBackType) => {
        setLoading(true);
        await new Promise(resolve => setTimeout(resolve, 1500));
        console.log(`Added seat ${number}, row ${row}, id ${id}`);
        const newTooltip = 'Seleccionado';
        addCb(row, number, id, newTooltip);
        setLoading(false);
    };

    const removeSeatCallback = async ({row, number, id}: SeatInterface, removeCb: RemoveCallBackType) => {
        setLoading(true);
        await new Promise(resolve => setTimeout(resolve, 1500));
        console.log(`Removed seat ${number}, row ${row}, id ${id}`);
        const newTooltip = null;
        removeCb(row, number, newTooltip);
        setLoading(false);
    };

    const addCart = () => {
        if(!dateClicked) {
            setOpenDatePopup(true);
        } else {
            amount = (+ visitas.total.toFixed(2)) * 100;
            if(trayecto && operationLine && bu) {
                let tokenTicket = sessionStorage.getItem('tokenTicket');
                if(!tokenTicket) {
                    tokenTicket = generateTokenticket(20);
                    sessionStorage.setItem('tokenTicket', tokenTicket);
                }

                const ticket = mountPayload(operationLine.qrTicket + generateTokenticket(TICKET_LENGTH-operationLine.qrTicket.length), dateClicked, selectedHour, +visitas.base.toFixed(2), +trayecto.tax.value.toFixed(2), trayecto.tax.name, operationLine.id, 
                    operationLine.name, bu.name, bu.tin, trayecto.id, trayecto.name, trayecto.vuelta, trayecto.hoponHopoff,
                    trayecto.tramoHora, trayecto.timeExpiration, trayecto.timeAdvance, trayecto.tramoHoraVuelta, trayecto.origin, trayecto.destination, trayecto.timeDelay,
                    trayecto.timeUse, trayecto.aditionalInfo, amount, trayecto.prices, visitas, trayecto.tax.id, visitas.extras);                            
                additional_info = JSON.stringify({
                    stretchName: trayecto.name,
                    stretchDescription: trayecto.description,
                    tokenticket: tokenTicket,
                    description: description
                });

                const uuid = sessionStorage.getItem('idCompra');
                
                addToCart(trayecto.id, ticket, additional_info, (uuid) ? uuid : undefined).then((res) => {
                    // Comprobamos si es un número
                    if((/^[0-9]*$/).test(res)) {
                        const statusCode: number = +res;
                        let message: string = "";
                        switch (statusCode) {
                            case 400:
                                message = "El token no existe.";
                                break;
                            case 404:
                                message = 'Ya tiene agregada esa experiencia al carrito, si quiere modificarla tendrá que eliminarla primero del carrito.';
                                break;
                            case 410:   
                                message = "Error al generar el ticket.";
                                break;
                            case 412:
                                message = "Hemos obtenido un error.";
                                break;
                            case 413:
                                message = "No hay aforo suficiente.";
                                break;
                            case 414:
                                message = "El servicio que quiere reservar no está disponible.";
                                break;
                            case 415:
                                message = "El servicio está deshabilitado para esa fecha.";
                                break;
                            case 416:
                                message = "El servicio está deshabilitado para esa hora.";   
                                break;
                            case 500:
                                message = "Error interno del servidor.";
                                break;
                            default:
                                message = "Lo siento, hemos obtenido un error inesperado.";
                                break;
                        }
                        
                        history.push(`/error/${message}/${bu.id}`);
                    } else { // En caso de no ser un número, es la url
                        if(!uuid) {
                            sessionStorage.setItem('idCompra', res.uuid);
                        }
                        history.push(`/cart/${bu.id}`);
                    }
                });
            }
            
        }
    };

    return(
        <div className="page-wrapper animated fadeIn">
            <header className="book-embed-nav with-padding respond-print-hide">
                <div className="ben-right">
                    <ul className="ben-left">
                        <li className="ben-flyout-wrap">
                            <button className="ben-item ben-secure-button fh-green" type="button"
                                    aria-expanded="false">
                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"
                                     id="icon-svg-lock" className="icon-svg-lock" width="11" height="14"
                                     viewBox="0 0 11.02 14" ng-svg="icon-svg-lock">
                                    <path d="M7.66,3.88a2.15,2.15,0,0,0-4.3,0v2h4.3Z" style={{fill: 'none'}}></path>
                                    <path
                                        d="M9.39,5.85v-2a3.88,3.88,0,0,0-7.76,0v2A1.72,1.72,0,0,0,0,7.56v4.73A1.72,1.72,0,0,0,1.71,14h7.6A1.72,1.72,0,0,0,11,12.29V7.56A1.71,1.71,0,0,0,9.39,5.85Zm-6-2a2.15,2.15,0,0,1,4.3,0v2H3.36Z"></path>
                                </svg>
                                Pago Seguro
                            </button>

                        </li>

                        <li className="ben-flyout-wrap">

                            <div>
                                <a className="ben-item ben-cart-button fade-in-up" type="button"
                                        aria-expanded="false" href={`/cart/${bu?.id}`}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" id="icon-cart"
                                         className="icon-cart" width="27" height="23" viewBox="0 0 27 23" style={{fill: 'white'}}
                                    >
                                        <path
                                            d="M24.47,16.68H7.12l-3.74-14H.08V.21H5.42l3.74,14H22.31l1.58-8.48H11.25V3.22H26.92Z"></path>
                                        <path d="M23,20.59a2.2,2.2,0,1,0-2.2,2.2A2.19,2.19,0,0,0,23,20.59Z"></path>
                                        <path d="M12.19,20.59A2.2,2.2,0,1,0,10,22.79,2.19,2.19,0,0,0,12.19,20.59Z"></path>
                                    </svg>
                                    <span className="respond-handhelds-hide">Carrito</span>
                                    <span className="respond-desktop-hide"></span>
                                </a>
                            </div>

                        </li>
                    </ul>
                    <div className="ben-flyout-wrap" ng-if="lightframe.isLightframe() || backUrl">
                        <button className="ben-item ben-close-button test-toggle-leave-flyout-action" type="button"
                                aria-expanded="false">
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" id="icon-x"
                                 className="icon-x" width="14" height="14" viewBox="0 0 14 14" >
                                <polygon
                                    points="14 1.75 12.25 0 7 5.25 1.75 0 0 1.75 5.25 7 0 12.25 1.75 14 7 8.75 12.25 14 14 12.25 8.75 7 14 1.75"></polygon>
                            </svg>
                            <span className="visually-hidden">Cerrar</span>
                        </button>

                    </div>
                </div>

            </header>
            {
                trayecto && bu && 
                <nav className="flow-breadcrumbs test-breadcrumbs-indicator" aria-label="Breadcrumb">
                    <ol>
                        <li className="test-flow-node-breadcrumb" aria-label="Home"
                            title="Home">
                            <a href={`/${bu.id}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" id="icon-home"
                                     className="icon-home" width="13" height="13" viewBox="0 0 13 13"
                                >
                                    <path
                                        d="M5.63.28l-5,3.54A1.61,1.61,0,0,0,0,5.15v6.52A1.32,1.32,0,0,0,1.34,13H4.46V9.66a2.06,2.06,0,0,1,4.12,0h0V13h3.08A1.31,1.31,0,0,0,13,11.72V5.15a1.66,1.66,0,0,0-.68-1.33L7.41.28A1.57,1.57,0,0,0,5.63.28Z"></path>
                                </svg>
                            </a>
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" id="icon-arrow-rounded"
                                 className="icon-arrow-rounded" width="12" height="10" viewBox="0 0 12 10"
                            >
                                <path
                                    d="M11.72,4.25,7.77.3A1,1,0,0,0,6.36,1.63l0,0L8.73,4H1A1,1,0,1,0,1,5.93H8.71L6.4,8.25a1,1,0,0,0,0,1.37,1,1,0,0,0,1.34,0l4-3.95A1,1,0,0,0,12,5v0A1,1,0,0,0,11.72,4.25Z"></path>
                            </svg>
                        </li>
                        <li className="breadcrumb-current test-current-breadcrumb" aria-current="location">
                            { trayecto.name }
                        </li>
                    </ol>
                </nav>
            }
        <section className="page-header tour-two tour-list destinations-details">
            <div className="container">
                <div className="row">

                    {
                        !trayecto &&
                            <>
                        <div className="col-7">
                            <div className='text-input__loading'>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                                <div className='text-input__loading--line'></div>
                            </div>
                        </div>
                        <div className="col-5">
                        <div className='text-input__loading'>
                        <div className='text-input__loading--line'></div>
                        <div className='text-input__loading--line'></div>
                        <div className='text-input__loading--line'></div>
                        <div className='text-input__loading--line'></div>
                        <div className='text-input__loading--line'></div>
                        <div className='text-input__loading--line'></div>
                        <div className='text-input__loading--line'></div>
                        <div className='text-input__loading--line'></div>
                        <div className='text-input__loading--line'></div>
                        <div className='text-input__loading--line'></div>
                            <div className='text-input__loading--line'></div>
                            <div className='text-input__loading--line'></div>
                            <div className='text-input__loading--line'></div>
                            <div className='text-input__loading--line'></div>
                            <div className='text-input__loading--line'></div>
                            <div className='text-input__loading--line'></div>
                            <div className='text-input__loading--line'></div>
                            <div className='text-input__loading--line'></div>
                            <div className='text-input__loading--line'></div>
                            <div className='text-input__loading--line'></div>
                        </div>
                        </div>

                        </>
                    }

            {
                trayecto &&


<div className="col-lg-6">




                    <div className="destinations-details__content">
                        <h3 className="destinations-details__title">{trayecto.name}</h3>
                        <p>{trayecto.description}</p>
                        {
                            !trayecto.image &&
                                <>
                                <img src="/Assets/images/unnamed.jpg" className="img-fluid"
                                    alt="Sin imagen" />
                                </>
                        }
                        {
                            trayecto.image &&
                                <>
                            <img src={imagen} className="img-fluid"
                                 alt={trayecto.name} />
                            </>
                        }

                        {
                            trayecto.aditionalInfo &&
                            <p>{trayecto.aditionalInfo}</p>
                        }


                    </div>

                </div>

            }
            {
                trayecto &&
                <div className="col-lg-6">
                    <div className="tour-sidebar">
                        <div className="tour-sidebar__featured">
                            <div className="book-online-cta">
                                <h2>Reserva 100% Online</h2>
                                <ul>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" id="icon-clock"
                                             className="icon-clock" width="13" height="13" viewBox="0 0 13 13"
                                             ng-svg="icon-clock">
                                            <path
                                                d="M6.47,0a6.47,6.47,0,1,0,6.47,6.47h0A6.47,6.47,0,0,0,6.47,0m0,11.5a5,5,0,1,1,5-5,5,5,0,0,1-5,5m2.16-5H7.19V3.59a.72.72,0,1,0-1.44,0v3.6a.72.72,0,0,0,.72.72H8.63a.72.72,0,0,0,0-1.44"></path>
                                        </svg>
                                        Disponibilidad en tiempo real
                                    </li>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" id="icon-bolt"
                                             className="icon-bolt" width="9" height="14" viewBox="0 0 9 14"
                                             ng-svg="icon-bolt">
                                            <path
                                                d="M8.88,5.91a.88.88,0,0,0-.79-.39H6V.82A.77.77,0,0,0,5.53.05a.8.8,0,0,0-.85.21l-4.57,7a.88.88,0,0,0,0,.87.88.88,0,0,0,.79.39H3l.12,4.7a.78.78,0,0,0,.45.77.86.86,0,0,0,.27.05.83.83,0,0,0,.58-.26l4.42-6.9,0-.06A.88.88,0,0,0,8.88,5.91Z"></path>
                                        </svg>
                                        Confirmaci&oacute;n Instant&aacute;nea
                                    </li>
                                </ul>
                            </div>
                    
                        <div className="fechas">

                    <FullCalendar
                        plugins={[ dayGridPlugin, interactionPlugin ]}
                        initialView="dayGridMonth"
                        events={dd}
                        dateClick={clickDateHandler}
                        selectable={true}
                        locale="es"
                        buttonText={{today: 'Hoy'}}
                    />
                    {
                        dateClicked !== "" &&
                        <p className="lead">
                            <b>Fecha seleccionada:</b> {Moment(dateClicked).format("DD/MM/YYYY")}
                        </p>
                    }
                </div>
                    <Dialog onClose={closeClickDateHandler} aria-labelledby="customized-dialog-title" open={openDatePopup} >
                        <DialogTitle id="customized-dialog-title">FECHA NO DISPONIBLE</DialogTitle>
                        <DialogContent dividers>
                            <Typography gutterBottom>
                                <b>Fecha no disponible, seleccione otra fecha por favor</b>
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            <button type="button" className="btn btn-primary" onClick={closeClickDateHandler} >Cerrar</button>
                        </DialogActions>
                        </Dialog>
                    {
                        trayecto.horasIda && trayecto.horasIda.length !== 0 &&
                        <div className="horas">
                            <h3>Hora de Salida</h3>
                                    <select className="custom-select" id="hourSelect" onChange={horaChangeHandler} >
                                        {
                                            trayecto.horasIda.map((hora) => {
                                                const horaString = ((hora.hours.toString().length === 1) ? "0" : "") + hora.hours.toString() + hora.minutes.toString();
                                                const horaSalida = Moment(horaString, "HHmm").format('HH:mm');
                                                return (
                                                    <option value={trayecto.horasIda.indexOf(hora)} key={hora.id}>
                                                        {horaSalida}
                                                    </option>
                                                );
                                            })
                                        }
                                    </select>
                        </div>
                    }
                    {
                        trayecto.prices && trayecto.prices.length !== 0 &&
                        <h3 className="preciosHeading">
                            Precios
                        </h3>
                    }

                    {
                        trayecto.prices && trayecto.prices.length !== 0 && trayecto.prices.map((precio) => {
                            const precioViaje = precio.price + precio.price * trayecto.tax.value;
                            const index = trayecto.prices.indexOf(precio);
                            return(
                                <div className="opciones">
                                    {
                                        precio.passengerCategory.name &&
                                        <div className="row row-cols-auto text-left align-items-center">
                                            <div className="col-5">
                                                <div className="row row-cols-auto">

                                                    <div className="col">
                                                        <strong> {primeraLetraMayuscula(precio.passengerCategory.name)}</strong>
                                                    </div>
                                                </div>
                                                <div className="row row-cols-auto">

                                                    <div className="col">
                                                        {precioViaje.toFixed(2)} €
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-2 nopadbado">
                                                {visitas.price[index] && visitas.price[index].toFixed(2)} €
                                            </div>
                                            <div className="col-2 nopadbad">
                                                <button className="w-100 btn btn-lg btn-outline-primary" value={index} onClick={quitarVisitante} name="delete" ><span>-</span></button>
                                            </div>
                                            <div className="col-1 nopadbado">
                                                {visitas.vis[index]}
                                            </div>
                                            <div className="col-2 nopadbad">
                                                <button className="w-100 btn btn-lg btn-outline-primary" value={index} name="add" onClick={addVisitante} ><span>+</span></button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            );
                        })
                    }

                    {
                        disabled &&
                        <div>
                            Esta experiencia estará disponible próximamente. Disculpe las molestias
                        </div>
                    }

                    <Dialog onClose={closeClickReservarHandler} aria-labelledby="customized-dialog-title" open={openReservarPopup} >
                        <DialogTitle id="customized-dialog-title">Seleccione algún elemento</DialogTitle>
                        <DialogContent dividers>
                            <Typography gutterBottom>
                                <b>No ha seleccionado ningún elemento y no se puede reservar.</b>
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            <button type="button" className="btn btn-primary" onClick={closeClickReservarHandler} >Cerrar</button>
                        </DialogActions>
                    </Dialog>
                    {
                        trayecto.extras && trayecto.extras.length !== 0 && 
                        <h3 className="preciosHeading">
                            Extras
                        </h3>
                    }

                    {
                        trayecto.extras && trayecto.extras.length !== 0 && 
                        trayecto.extras.map((extra: Extras) => {
                            return (
                                <div className="input-group mb-3" key={extra.id} >
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">
                                            <input type="checkbox" name={extra.name}
                                                value={trayecto.extras.indexOf(extra)} key={extra.id} id={extra.id.toString()} onChange={extrasChangeHandler} />
                                        </div>
                                    </div>
                                    <input type="text" className="form-control" readOnly value={extra.description + " - " + (extra.price + extra.price * extra.tax.value).toFixed(2) + "€"} />
                                </div>
                            )
                        })
                    }

                    {
                        trayecto.seats &&
                        <>
                            <SeatPicker
                                addSeatCallback={addSeatCallback}
                                removeSeatCallback={removeSeatCallback}
                                rows={trayecto.seats}
                                maxReservableSeats={totalSeats}
                                alpha
                                visible
                                selectedByDefault
                                loading={loading}
                                tooltipProps={{ multiline: true }}
                            />
                        </>
                    }


                            <div className="book-form-totals">

                                            <p className='totalAlign'>
                                                <b>Total: </b> { visitas.total.toFixed(2) } €
                                            </p>
                            </div>



                            <button type="button" disabled={disabled} className="btn-huge btn-wide btn-blue test-add-to-cart-action-enabled" onClick={addCart} >A&ntilde;adir al carrito</button>
                </div>
                    </div>
                </div>

            }

                </div>
                </div>
        </section>
            <footer className="book-embed-footer">
                <div className="book-embed-footer-left">
                    <div>
                        <div className="ben-translate-toggle respond-print-hide">
                            <button className="ben-item ben-translate-button capitalize" type="button"
                                    aria-describedby="translate-btn-describe"
                                    aria-expanded="false">
                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" id="icon-globe"
                                     className="icon-globe" width="14" height="14" viewBox="0 0 14 14"
                                     ng-svg="icon-globe">
                                    <path
                                        d="M14 7a7 7 0 11-7-7 7 7 0 017 7zM4 7.51v1h2.41c.41 0 .59.19.59.6v1.81c0 .91.14.74-.67 1.34l-.76.58a6.09 6.09 0 005.3-1.24l-.17-.19-1.48-1.48A.65.65 0 019 9.41V7.62c0-.11-.46 0-.46-.12h-.86c-.41 0-.59-.19-.59-.59V5.66A.67.67 0 017.46 5c1.07-.67 2.54-1.35 3.62-2l.24-.15-.83-.72-2.62 1.72a.53.53 0 01-.81-.08L4.88 1.58c-.1-.09-.17-.13-.3-.07a6.13 6.13 0 00-2.64 2.27 2 2 0 00-.12.22h3.56c.44 0 .62.18.62.62v2.29c0 .4-.18.58-.58.59zm1-1V5H1.55a.24.24 0 00-.27.2 6 6 0 003 7.16.21.21 0 00.28 0 9.64 9.64 0 011-.71.87.87 0 00.44-.97 11.76 11.76 0 010-1.19H3.62c-.44 0-.62-.17-.62-.61V7.09c0-.4.18-.58.58-.59zm6.58 4.36a5.89 5.89 0 00.36-7.22c-1.11.7-2.64 1.4-3.76 2.1a.2.2 0 00-.08.12v.63h1.33a.51.51 0 01.57.58v2.05a.35.35 0 00.07.23zm-4-8l1.93-1.31a6 6 0 00-3.64-.45c.57.58 1.13 1.15 1.72 1.73z"></path>
                                </svg>
                                Espa&ntilde;ol (ES)
                            </button>

                        </div>
                    </div>

                </div>
                <div className="book-embed-footer-right">
                    <img src="https://res.cloudinary.com/marketingpyme/image/upload/w_160,h_45,c_fill/servicios/logotipo-civitrip.png" className="img-fluid __web-inspector-hide-shortcut__" alt="CIVITRIP" />
                </div>

            </footer>
</div>
    );
}
